import AdviceAssetAllocation from './AdviceAssetAllocation'
import DesktopAssetAllocation from './DesktopAssetAllocation'
import MobileAssetAllocation from './MobileAssetAllocation'

export default AdviceAssetAllocation
export { DesktopAssetAllocation, MobileAssetAllocation }
